import * as React from "react"
import { cn } from "@/lib/utils"

const Card = React.forwardRef(({ className, style, ...props }, ref) => {
  const mergedStyle = Object.assign({ backgroundColor: 'var(--card)', border: '1px solid var(--border)', borderRadius: '12px' }, style);
  return (
  <div
    ref={ref}
    style={mergedStyle}
    className={cn("text-card-foreground shadow-2xl transition-all", className)}
    {...props} />
  );
})
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-2 p-8", className)}
    {...props} />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, style, ...props }, ref) => {
  const mergedStyle = Object.assign({ fontFamily: "'Poppins', sans-serif" }, style);
  return (
  <div
    ref={ref}
    style={mergedStyle}
    className={cn("text-[13px] font-bold uppercase tracking-wide", className)}
    {...props} />
  );
})
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, style, ...props }, ref) => {
  const mergedStyle = Object.assign({ fontFamily: "'Inter', sans-serif" }, style);
  return (
  <div
    ref={ref}
    style={mergedStyle}
    className={cn("text-sm text-muted-foreground leading-relaxed", className)}
    {...props} />
  );
})
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-8 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex items-center p-8 pt-0", className)}
    {...props} />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
